<template>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" v-if="client">
        <v-toolbar color="secondary" dark absolute>
            <v-icon @click="hide">close</v-icon>
            <v-toolbar-title>Detalles del {{ clientLabel }}</v-toolbar-title>
        </v-toolbar>
        <v-card>

            <v-container class="pt-4">
                <v-layout wrap mt-4 pt-4 v-if="client">
                    <v-flex xs12 md10 offset-md1 lg8 offset-lg2>
                        <v-card-text class="pb-0">
                            <v-layout wrap align-center>
                                <v-flex xs10 md8 text-xs-center text-md-left pa-0>
                                    <v-list three-line class="py-0">
                                        <v-list-tile avatar>
                                            <v-list-tile-avatar>
                                                <v-avatar size="45" class="mt-3">
                                                    <v-img
                                                        :src="client && client.avatar || getFakeAvatar(client.gender)"></v-img>
                                                </v-avatar>
                                            </v-list-tile-avatar>

                                            <v-list-tile-content>
                                                <v-list-tile-title>{{ client.first_name }}
                                                    {{ client.last_name || '' }}
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    Paciente desde:
                                                    {{ $moment(client.created_At).format('DD-MM-YYYY') }}
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-flex>
                                <v-flex xs2 md4 text-xs-right>
                                    <v-btn fab small round @click="showClientHistory" color="teal" dark
                                           class="hidden-md-and-up">
                                        <v-icon size="16">fa-history</v-icon>
                                    </v-btn>
                                    <v-btn round @click="showClientHistory" color="teal" dark
                                           class="hidden-sm-and-down">
                                        <v-icon size="16" class="mr-1">fa-history</v-icon>
                                        historial
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>

                        <v-card-text class="pt-1">
                            <v-card flat class="mx-2 my-2 kim-card" :color="dark ? 'secondary' : 'grey lighten-3'">
                                <v-layout wrap px-4 py-3>

                                    <v-btn small color="secondary lighten-1" fab absolute right
                                           @click="onClientEditClick(client)">
                                        <v-icon>fa-pen</v-icon>
                                    </v-btn>

                                    <v-flex xs12 md5 v-if="client">
                                        <v-flex xs12 class="body-2 mb-2 text-xs-left secondary--text">
                                            <v-icon size="18" class="mr-2" color="secondary">fa-user</v-icon>
                                            <span class="subtitle">Datos:</span>
                                        </v-flex>
                                        <v-layout wrap pl-2>
                                            <v-flex xs12 text-xs-left>
                                                <span class="font-weight-bold">RUT:</span>
                                                {{ clientRut }}
                                            </v-flex>
                                            <v-flex xs12 text-xs-left>
                                                <span class="font-weight-bold">Edad:</span>
                                                {{ client.birth_date && `${$moment().diff($moment(client.birth_date), 'years')} años` || 'n/d' }}
                                            </v-flex>
                                            <v-flex xs12 text-xs-left text-truncate>
                                                <div>
                                                    <span class="font-weight-bold">Dirección:</span>
                                                    {{ client.address || 'n/d' }}
                                                </div>
                                            </v-flex>
                                            <v-flex xs12 text-xs-left text-truncate v-if="client.address_line1">
                                                <div>
                                                    <span class="font-weight-bold">Casa/Dpto/Local:</span>
                                                    {{ client.address_line1 }}
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 pa-0 my-2 hidden-md-and-up>
                                        <v-divider></v-divider>
                                    </v-flex>

                                    <v-flex xs12 md7 v-if="client">
                                        <v-flex xs12 class="body-2 mb-2 text-xs-left secondary--text">
                                            <v-icon size="18" class="mr-2" color="secondary">fa-phone</v-icon>
                                            <span class="subtitle">Contacto:</span>
                                        </v-flex>
                                        <v-layout wrap pl-2>
                                            <v-flex xs12 text-xs-left>
                                                <span class="font-weight-bold">Teléfono (móvil):</span>
                                                {{ client.phone1 || 'n/d' }}
                                            </v-flex>
                                            <v-flex xs12 text-xs-left>
                                                <span class="font-weight-bold">Teléfono (fijo):</span>
                                                {{ client.phone2 || 'n/d' }}
                                            </v-flex>
                                            <v-flex xs12 text-xs-left text-truncate>
                                                <div :title="client.email">
                                                    <span class="font-weight-bold">E-mail:</span>
                                                    {{ client.email || 'n/d' }}
                                                </div>
                                            </v-flex>

                                        </v-layout>
                                    </v-flex>

                                </v-layout>
                            </v-card>
                        </v-card-text>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>

        <client-edit
            :required-fields="requiredFields"
            :requested-fields="requestedFields"
            ref="clientEditForm"
            @success="onClientUpdated"
        />

        <client-attention-history ref="clientHistory"/>

    </v-dialog>
</template>

<script>

import {getFakeAvatar} from "@/utils/Common";
import {getLabel} from '@/utils/Institution'
import ClientEdit from "../appointments/ClientEdit";
import {mapState} from "vuex";
import ClientAttentionHistory from "../appointments/attention/ClientAttentionHistory";

export default {
    name: "ClientDetails",
    components: {ClientAttentionHistory, ClientEdit},
    props: {
        client: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dialog: false
        }
    },
    methods: {
        getFakeAvatar,
        showClientHistory() {
            const vm = this
            vm.$refs.clientHistory.show(vm.client.id)
        },
        onClientEditClick(client) {
            const vm = this
            vm.$refs.clientEditForm.show(client)

        },
        onClientUpdated(client) {
            const vm = this
            vm.$refs.clientEditForm.hide()
            vm.$emit('edit:client', client)
        },
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
        }
    },
    computed: {
        ...mapState(['currentProvider', 'dark']),
        requiredFields() {
            const vm = this
            if (!vm.currentProvider || !vm.currentProvider.settings || !vm.currentProvider.settings.client_form_fields) return []
            return vm.currentProvider.settings.client_form_fields
                .filter(field => field.pivot.required)
                .map(field => field.name)
        },

        requestedFields() {
            const vm = this
            if (!vm.currentProvider || !vm.currentProvider.settings || !vm.currentProvider.settings.client_form_fields) return []
            return vm.currentProvider.settings.client_form_fields
                .map(field => field.name)
        },
        clientLabel() {
            return `${getLabel('commons.client.singular')}`
        },
        clientRut(vm = this) {
            if (!vm.client) return 'n/d'
            let rut = vm.client.dni
            return vm.client.is_foreign ? rut : vm.$options.filters.rut(rut)
        }
    }
}
</script>

<style scoped>

</style>